import {Directive, ElementRef} from '@angular/core';
import {NgControl} from '@angular/forms';

// Add access to nativeElement (use case, trigger focus from a formControl)
// https://stackoverflow.com/questions/39642547/is-it-possible-to-get-native-element-for-formcontrol
@Directive({
  selector: '[ngModel]'
})
export class NativeElementInjectorDirective {
  constructor(private el: ElementRef, private control: NgControl) {
    setTimeout(() => {
      if (control && control.control) {
        (<any>control.control).nativeElement = el.nativeElement;
      }
    });

  }
}
